import React from "react";

export const CommissionContext = React.createContext({});

export const CommissionProvider = CommissionContext.Provider;
